import React from 'react';
import { Box } from '@mui/material';

const StepItem = ({ children, tabKey, activeTabKey }) => {
  return activeTabKey !== tabKey ? null : <Box>{React.cloneElement(children, {})}</Box>;
};

export default StepItem;
